/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Dialog, DialogContent, DialogTitle, Fade, IconButton, Modal } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import CloseIcon from "@material-ui/icons/Close";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary"; // Import the gallery icon
import LegendaryBegginingSection from "./subcomponents/LegendaryBeginningSection";

/* Data Imports */
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    position: "relative",
    objectFit: "cover",
    width: "100%",
    margin: "0rem 0rem 2rem 0rem",
    [theme.breakpoints.down("sm")]: {
      height: "255px", // Match the mobile image height
    },
  },
  illustrationSizer: {
    objectFit: "cover",
    width: "100%",
    height: "94vh",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "255px", // Adjust height for mobile
      margin: "0 auto", // Center the image horizontally
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      height: "35vh", // Adjust height for mobile
      margin: "0 auto", // Center the image horizontally
    },
    [theme.breakpoints.up("md")]: {
      width: "100%",
      height: "38vh", // Adjust height for mobile
      margin: "0 auto", // Center the image horizontally
    },
    [theme.breakpoints.up("lg")]: {
      width: "100%",
      height: "94vh", // Adjust height for mobile
      margin: "0 auto", // Center the image horizontally
    },

    // [theme.breakpoints.up("sm")]: {
    //   width: "100%",
    //   height: "40vh", // Adjust height for larger screens
    // },

    // [theme.breakpoints.down("lg")]: {
    //   width: "100%",
    //   height: "37vh", // Adjust height for larger screens

    // },
  },
  overlay: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 2,
    color: "#fff",
    borderRadius: "1.5rem 1.5rem 0rem 0rem",
    width: "60%",
    //     [theme.breakpoints.down("sm")]: {
    //       position:"relative",
    //       width: "90%",
    //       height: "auto",
    // margin:"1.5rem 0rem 0rem 0rem",
    //       borderRadius: "1.5rem 1.5rem 1.5rem 1.5rem",
    //     },
    //     [theme.breakpoints.down("md")]: {
    //       position:"relative",
    //       width: "90%",
    //       height: "auto",
    // margin:"1.5rem 0rem 0rem 0rem",
    //       borderRadius: "1.5rem 1.5rem 1.5rem 1.5rem",
    //     },
    [theme.breakpoints.down("lg")]: {
      display: "none",
    },
  },
  seeAllButton: {
    position: "absolute",
    bottom: "0",
    right: "0",
    background: "rgba(0, 0, 0, 0.5)",
    color: "#fff",
    padding: "0.5rem 1rem",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "1rem 0 0 0",
    [theme.breakpoints.up("md")]: {
      //   display: "none",
      bottom: "5px",
    },
  },
  modalContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    backgroundColor: "#000",
  },
  modalImage: {
    // maxWidth: "90%",
    // maxHeight: "90%",
    width: "100%",
    height: "auto",
  },
  arrowButton: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#fff",
    zIndex: 4,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    fontSize: "2rem",

    "&:hover": {
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  arrowButtons: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#fff",
    zIndex: 4,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    fontSize: "1rem",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  closeButton: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
    // color: "#fff",
    zIndex: 5,
    [theme.breakpoints.up("md")]: {
      color: "#fff",
    },
  },
  arrowIcon: {
    color: "#0000008A",
    fontSize: "1.5rem",
    padding: "0.25rem",
  },
  arrowIcons: {
    color: "#0000008A",
    fontSize: "1.5rem",
    padding: "0.25rem",
  },
  modalContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalPaper: {
    backgroundColor: "#fff",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 0.3s ease-in-out",
  },
}));

const PropertyImage = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false); // For the single image modal
  const [galleryOpen, setGalleryOpen] = React.useState(false); // For the gallery modal
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [currentCategory, setCurrentCategory] = React.useState("all"); // Track the selected category
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const images = [
    "/images/icons/heavie/singleproperty/eden.webp",
    "/images/Gallery/elevation_1.webp",
    "/images/Gallery/elevation_2.webp",
    "/images/Gallery/elevation_3.webp",
    "/images/Gallery/living_room.webp",
    "/images/Gallery/master_bedroom.webp",
    "/images/Gallery/1st_floor.webp",
    "/images/Gallery/balcony.webp",
    "/images/Gallery/kids_play_area.webp",
    "/images/Gallery/pool.webp",
    "/images/Gallery/communityhall.webp",
    "/images/Gallery/gym.webp",
    "/images/Gallery/carparking.webp",
  ];

  const categorizedImages = {
    all: [
      { img: "/images/Gallery/elevation_1.webp", alt: "Elevation-1" },
      { img: "/images/Gallery/elevation_2.webp", alt: "Exterior View" },
      { img: "/images/Gallery/elevation_3.webp", alt: "Elevation-2" },
      { img: "/images/Gallery/living_room.webp", alt: "Living Room" },
      { img: "/images/Gallery/master_bedroom.webp", alt: "Master Bedroom" },
      { img: "/images/Gallery/kitchen.webp", alt: "Kitchen" },
      { img: "/images/Gallery/1st_floor.webp", alt: "Bedroom" },
      { img: "/images/Gallery/balcony.webp", alt: "Balcony" },
      { img: "/images/Gallery/kids_play_area.webp", alt: "Kids Play Area" },
      { img: "/images/Gallery/pool.webp", alt: "Swimming Pool" },
      { img: "/images/Gallery/communityhall.webp", alt: "Community Hall" },
      { img: "/images/Gallery/gym.webp", alt: "Gym" },
      { img: "/images/Gallery/carparking.webp", alt: "Car Parking" },
    ],
    elevation: [
      { img: "/images/Gallery/elevation_2.webp", alt: "Exterior View" },
      { img: "/images/Gallery/elevation_1.webp", alt: "Elevation-1" },
      { img: "/images/Gallery/elevation_3.webp", alt: "Elevation-2" },
    ],
    interior: [
      { img: "/images/Gallery/living_room.webp", alt: "Living Room" },
      { img: "/images/Gallery/master_bedroom.webp", alt: "Master Bedroom" },
      { img: "/images/Gallery/kitchen.webp", alt: "Kitchen" },
      { img: "/images/Gallery/1st_floor.webp", alt: "Bedroom" },
      { img: "/images/Gallery/balcony.webp", alt: "Balcony" },
      { img: "/images/Gallery/Workstation_Area.webp", alt: "Workstation Area" },
    ],
    amenities: [
      { img: "/images/Gallery/Bonfire1.webp", alt: "Bonfire" },
      { img: "/images/Gallery/kids_play_area.webp", alt: "Kids Play Area" },
      { img: "/images/Gallery/pool.webp", alt: "Swimming Pool" },
      { img: "/images/Gallery/communityhall.webp", alt: "Community Hall" },
      { img: "/images/Gallery/gym.webp", alt: "Gym" },
      { img: "/images/Gallery/carparking.webp", alt: "Car Parking" },
      { img: "/images/Gallery/Terrace_Lounge_area.webp", alt: "Terrace Lounge Area" },
    ],
  };

  const handleCategoryClick = (category) => {
    if (categorizedImages[category]) {
      setCurrentCategory(category);
      setCurrentIndex(0); // Reset index
      setOpen(true);
    }
  };
const handleGalleryOpen = () => {
  if (isMobile) {
    setGalleryOpen(true);
  } else {
    handleOpen(currentIndex);
  }
};

  const handleGalleryClose = () => {
    setGalleryOpen(false);
  };

  const handleOpen = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNext = () => {
    const categoryImages = categorizedImages[currentCategory];
    setCurrentIndex((prevIndex) => (prevIndex + 1) % categoryImages.length);
  };

  const handlePrev = () => {
    const categoryImages = categorizedImages[currentCategory];
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? categoryImages.length - 1 : prevIndex - 1));
  };

  const handleArrowClick = (direction) => {
    if (isMobile) {
      // On mobile, only change the image
      if (direction === "next") {
        handleNext();
      } else {
        handlePrev();
      }
    } else {
      // On desktop, open the modal
      handleOpen(currentIndex);
    }
  };

  // Swipe detection variables
  const touchStartRef = React.useRef(null);
  const touchEndRef = React.useRef(null);

  const handleTouchStart = (e) => {
    touchStartRef.current = e.touches[0].clientX; // Record the starting touch position
  };

  const handleTouchMove = (e) => {
    touchEndRef.current = e.touches[0].clientX; // Update the touch position as the user moves
  };

  const handleTouchEnd = () => {
    if (!touchStartRef.current || !touchEndRef.current) return;

    const swipeDistance = touchStartRef.current - touchEndRef.current;

    // Determine if the swipe is significant enough to count
    if (swipeDistance > 50) {
      // Swipe left
      handleNext();
    } else if (swipeDistance < -50) {
      // Swipe right
      handlePrev();
    }

    // Reset touch references
    touchStartRef.current = null;
    touchEndRef.current = null;
  };

  React.useEffect(() => {
    if (!open) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 5000); // 2000ms = 2 seconds
      return () => clearInterval(interval);
    }
  }, [open]);

  return (
    <React.Fragment>
      <div
        className={classes.megaContainer}
        onTouchStart={isMobile ? handleTouchStart : null}
        onTouchMove={isMobile ? handleTouchMove : null}
        onTouchEnd={isMobile ? handleTouchEnd : null}
      >
        <div
          className={classes.seeAllButton}
          onClick={handleGalleryOpen}
        >
          <PhotoLibraryIcon style={{ marginRight: "0.5rem" }} /> See All Images
        </div>
        <IconButton
          className={classes.arrowButton}
          style={{
            left: "1rem",
          }}
          onClick={() => handleArrowClick("prev")}
          size="small"
        >
          <ArrowBackIosIcon className={classes.arrowIcon} />
        </IconButton>
        <img
          src={images[currentIndex]}
          alt={AppConfig.imageAltText}
          width={512}
          height={512}
          loading="lazy"
          referrerPolicy="no-referrer"
          className={classes.illustrationSizer}
          onClick={() => {
            if (isMobile) {
              handleGalleryOpen();
            } else {
              handleOpen(currentIndex);
            }
          }}
        />
        <IconButton
          className={classes.arrowButton}
          style={{ right: "1rem" }}
          onClick={() => handleArrowClick("next")}
          size="small" // Makes the button smaller
        >
          <ArrowForwardIosIcon className={classes.arrowIcon} />
        </IconButton>
        <div className={classes.overlay}>
          <LegendaryBegginingSection />
        </div>
      </div>

      {/* Gallery Modal */}
      <Dialog
        open={galleryOpen}
        onClose={handleGalleryClose}
        fullScreen
      >
        <DialogTitle style={{ textAlign: "left", marginTop: "0.5rem", color: "#502761" }}>Gallery</DialogTitle>
        <IconButton
          className={classes.closeButton}
          onClick={handleGalleryClose}
          style={{ position: "absolute", top: "1rem", right: "1rem" }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ padding: "0rem 1rem 0rem 1rem", position: "relative" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              alignItems: "center",
              position: "relative",
            }}
          >
            {["all", "elevation", "interior", "amenities"].map((category) => (
              <div
                key={category}
                style={{
                  position: "relative",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={() => handleCategoryClick(category)}
              >
                <img
                  src={categorizedImages[category][0].img}
                  alt={category}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: "6px",
                    right: "0",
                    width: "30%",
                    background: "rgba(0, 0, 0, 0.5)",
                    color: "#fff",
                    padding: "0.5rem 0.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "1rem 0 0.5rem 0",
                  }}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>

      {/* Single Image Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        className={classes.modalContainer}
      >
        <Fade
          in={open}
          timeout={300}
        >
          <div
            className={`${classes.modalContent} ${classes.modalPaper}`}
            style={{ backgroundColor: "#fff" }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {/* Rest of the modal content remains the same */}
            <IconButton
              className={classes.arrowButtons}
              style={{ left: "1rem" }}
              onClick={handlePrev}
              size="small"
            >
              <ArrowBackIosIcon className={classes.arrowIcons} />
            </IconButton>

            <img
              src={categorizedImages[currentCategory][currentIndex].img}
              alt={categorizedImages[currentCategory][currentIndex].alt}
              className={classes.modalImage}
            />

            <IconButton
              className={classes.arrowButtons}
              style={{ right: "1rem" }}
              onClick={handleNext}
              size="small"
            >
              <ArrowForwardIosIcon className={classes.arrowIcons} />
            </IconButton>

            <IconButton
              className={classes.closeButton}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </Fade>
      </Modal>
    </React.Fragment>
  );
};

export default PropertyImage;
